import { joinPath } from '@/libs/react-router';

const ROOT_PATH = '/erp';
const EQUIPMENT_PATH = joinPath(ROOT_PATH, 'equipment');
const USER_LICENSES_PATH = joinPath(ROOT_PATH, 'user-licenses');
const PAYMENT_GATEWAYS_PATH = joinPath(ROOT_PATH, 'payment-gateways');

export const ErpPaths = {
  ROOT_PATH,

  EQUIPMENT_PATH,

  USER_LICENSES_PATH,

  PAYMENT_GATEWAYS_PATH,
} as const;
